import { VLazyLoadSelect } from '@vision/ui/components';
import { useSelectedAccountId } from '@vision/ui/hooks';
import { AIModel } from '@vision/ui/interfaces';
import { useLazyGetAIModelsQuery } from '@vision/ui/services';
import { useTranslation } from 'react-i18next';

type Props = {
  value: string | null;
  onChange: (value: string | null) => void;
};

export function ContentCategoryModelSelect({ value, onChange }: Props) {
  const accountId = useSelectedAccountId();
  const { t } = useTranslation('page-reports');

  return (
    <VLazyLoadSelect
      label={t('contentCategoryModel')}
      useLazyApiQueryFunction={useLazyGetAIModelsQuery}
      apiRequestParameters={{ nodeId: accountId, list: true }}
      singleSelectItemMapper={(model: AIModel) => ({ value: model.id, label: model.name })}
      value={value}
      onChange={onChange}
      clearable
      data-testid="input-content-category-models"
    />
  );
}
